export var TherapistType;
(function (TherapistType) {
    TherapistType["ALL"] = "Alle";
    TherapistType["MINE"] = "Meine";
    TherapistType["ARCHIVED"] = "Archivierte";
    TherapistType["SPECIFIC"] = "Specific";
})(TherapistType || (TherapistType = {}));
//# sourceMappingURL=therapist-type.enum.js.map